import React from 'react'
import './client-booking-list.css'
import BlackButton from '../../basic/button'

const Heloo = () => {
  window.alert('Mensagem de Teste')
}

const agenda = () => {
  return (
    <div className='app-container'>
      <p className='app-subtitle'>Horários Disponíveis</p>

      <div className="booking-container">

        <div className="booking-column">
          <div className="button-booking">
            <BlackButton Active={'true'} Label={'09:00'} Action={Heloo} />
          </div>

          <div className="button-booking">
            <BlackButton Active={'false'} Label={'11:00'} Action={Heloo} />
          </div>

          <div className="button-booking">
            <BlackButton Active={'false'} Label={'13:00'} Action={Heloo} />
          </div>
        </div>

        <div className="booking-column">
          <div className="button-booking">
            <BlackButton Active={'false'} Label={'10:00'} Action={Heloo} />
          </div>

          <div className="button-booking">
            <BlackButton Active={'false'} Label={'12:00'} Action={Heloo} />
          </div>

          <div className="button-booking">
            <BlackButton Active={'false'} Label={'14:00'} Action={Heloo} />
          </div>
                    <div className="button-booking">
            <BlackButton Active={'false'} Label={'10:00'} Action={Heloo} />
          </div>

          <div className="button-booking">
            <BlackButton Active={'false'} Label={'12:00'} Action={Heloo} />
          </div>

          <div className="button-booking">
            <BlackButton Active={'false'} Label={'14:00'} Action={Heloo} />
          </div>
                    <div className="button-booking">
            <BlackButton Active={'false'} Label={'10:00'} Action={Heloo} />
          </div>

          <div className="button-booking">
            <BlackButton Active={'false'} Label={'12:00'} Action={Heloo} />
          </div>

          <div className="button-booking">
            <BlackButton Active={'false'} Label={'14:00'} Action={Heloo} />
          </div>
                    <div className="button-booking">
            <BlackButton Active={'false'} Label={'10:00'} Action={Heloo} />
          </div>

          <div className="button-booking">
            <BlackButton Active={'false'} Label={'12:00'} Action={Heloo} />
          </div>

          <div className="button-booking">
            <BlackButton Active={'false'} Label={'14:00'} Action={Heloo} />
          </div>
        </div>

      </div>



    </div>
  )
}

export default agenda